// Get Sales Channels

import SalesChannels from '@/services/SalesChannels'
export default {
    data() {
        return {
            salesChannels: []
        }
    },
    methods: {
        getSalesChannels() {
            SalesChannels.getSalesChannels().then(res => {
                this.salesChannels = res
            })
        },
    }
}